<mat-card>
    <span class="paragraph coming-soon">
        Coming Soon!
    </span>
</mat-card>